
export const emails = [
"isagolivares@gmail.com",
"norma.campa@att.net",
"lee.alatorre@gmail.com",
"sonnysgirls@yahoo.com",
"anneherbert@mac.com",
"txrnc@aol.com",
"doragonzalez8987@comcast.com",
"jparkertx1@aol.com",
"noclue@aol.com",
"mrutledge6@me.com",
"billyclark@aol.com",
"joannzubik@yahoo.com",
"pcdmomtx@gmail.com",
"jarehage@yahoo.com",
"jrhage@yahoo.com",
"jparkertx@aol.com",
"catarinatownes@gmail.com",
"masstuart04@yahoo.com",
"lindawoodward9446@yahoo.com",
"mmstarry@aol.com",
"jessica.bonneau@puffer.com",
"clronnenkamp4@gmail.com",
"stoms1938@outlook.com",
"tbmplm80@gmail.com",
"smithgeri325@gmail.com",
"albertdee@att.net",
"nancynyc@comcast.net",
"balley_tx@yahoo.com",
"notyet@gmail.com",
"doesntuseemail@gmail.com",
"grayjames7421@yahoo.com",
"lczubas@sbcglobal.net",
"jan@jantheman.com",
"johnarusak@gmail.com",
"molinapestana120788@gmail.com",
"pdavis124@bellsouth.net",
"93601@noemail.upload",
"56801@noemail.upload",
"93551@noemail.upload",
"jet200k@gmail.com",
"janetbook02@yahoo.com",
"qarysma2008@gmail.com",
"laurajplatt@gmail.com",
"veronicalatuff@gmail.com",
"ammkahler@yahoo.com",
"mastuart04@yahoo.com",
"david_kech@yahoo.com",
"rdenton7455@gmail.com",
"jjacostaugas@gmail.com",
"caldwell.lori56@gmail.com",
"hquiel32@gmail.com",
"whitetiaopal@aol.com",
"94351@noemail.upload",
"joannbloom22@gmail.com",
"lkmoody2010@yahoo.com",
"lloydmclennon61@gmail.com",
"swhitman45@att.net",
"ilovegod247.mn@gmail.com",
"jfkidd@sbcglobal.net",
"larettablack3@gmail.com",
"yolandie@sbcglobal.net",
"doragonzalez8987@comcast.net",
"nphmar@swbell.net",
"gbone12000@yahoo.com",
"archived+txnc@aol.com",
"81351@noemail.upload",
"bridget.waterman@gmail.com",
"81151@noemail.upload",
"los2579@yahoo.com",
"terencechw@yahoo.com",
"84951@noemail.upload",
"lydiarios56@yahoo.com",
"kimberlywbraddock@gmail.com",
"gpspgs@comcast.net",
"onsherb@gmail.com",
"vanierobinson@gmail.com",
"pastorrcj@sbcglobal.net",
"72251@noemail.upload",
"db1707@windstream.net",
"derucker1960@gmail.com",
"tenz@consolodated.net",
"dsaunders14@yahoo.com",
"opavich@aol.com",
"steve.rioux001@yahoo.com",
"kyd4lyf@gmail.com",
"archived+87901@noemail.upload",
"letgal628@yahoo.com",
"dlbynum1@gmail.com",
"ortiz.rene1961@yahoo.com",
"vsaldana@swbell.net",
"tlbramlett@gmail.com",
"87851@noemail.upload",
"rivmi2015@yahoo.com",
"wandastewart@consolidated.net",
"archived+72751@noemail.upload",
"dingsion1@gmail.com",
"dtrichard2418@yahoo.com",
"cissybell@comcast.net",
"cissybell@comcast.net",
"ladybug78@consolidated.net",
"llevy005@comcast.net",
"jeannette_stevens@yahoo.com",
"lavernehassan@gmail.com",
"deborah5424@att.net",
"96901@noemail.upload",
"cecil4797@att.net",
"bpaige6129@gmail.com",
"rcaboche@comcast.net",
"sherry8127@hotmail.com",
"sgriffin@fcldental.com",
"dddjpv@gmail.com",
"whitehead.henry@gmail.com",
"slwp@sbcglobal.net",
"mh77@mycci.net",
"ednallewis@msn.com",
"86001@noemail.upload",
"96751@noemail.upload",
"monamonal@aol.com",
"elreed@gmail.com",
"nenabrito@yahoo.com",
"analugotx@gmail.com",
"ed.turknett@gmail.com",
"marymills43.65@gmail.com",
"mdurham1@yahoo.com",
"kathleen.crespy@gmail.com",
"melzie_1@hotmail.com",
"bstuart@go-axion.com",
"adenome@yahoo.com",
"rebeccayerdon@gmail.com",
"shirlrog@yahoo.com",
"ahozurn@gmail.com",
"jmearly3@yahoo.com",
"12451@noemail.upload",
"spunks@sbcglobal.net",
"40201@noemail.upload",
"4551@noemail.upload",
"93751@noemail.upload",
"87351@noemail.upload",
"rachgrendell@yahoo.com",
"misslady.2011@yahoo.com",
"86451@noemail.upload",
"sdaugherty@heritagetexas.com",
"richarduranga50@gmail.com",
"lorriecherry22@gmail.com",
"lindanodler@sbc.net",
"80801@noemail.upload",
"40351@noemail.upload",
"bwells@cbharper.com",
"82851@noemail.upload",
"97401@noemail.upload",
"93501@noemail.upload",
"73451@noemail.upload",
"mark.yuan@gmail.com",
"deahlynn@sbcglobal.net",
"leonor.martin25@yahoo.com",
"shannonk@davidkaehomes.com",
"savagescrapper@gmail.com",
"gg.turley@sbcglobal.net",
"jamoore1941@gmail.com",
"d26193@aol.com",
"gothberg@satx.rr.com",
"rmack2885@aol.com",
"bjclarkson103@gmail.com",
"nvsbear@yahoo.com",
"angelettp@yahoo.com",
"3101@noemail.upload",
"lakindred@mostynlaw.com",
"kris10fox@hotmail.com",
"rpankiw@icloud.com",
"spoonie115@aol.com",
"gatlin67@live.com",
"martinez9654@sbcglobal.net",
"joycecherek@earthlink.net",
"paulaharold@sbcglobal.net",
"baldwinpc@aol.com",
"jdmomto2@gmail.com",
"lbgraham1@gmail.com",
"markmittelsted@hotmail.com",
"85151@noemail.upload",
"8401@noemail.upload",
"archived+jlblove56@gmail.com",
"blarney0317@gmail.com",
"scpeters88@yahoo.com",
"87601@noemail.upload",
"osteenjody@yahoo.com",
"always.tugee22@gmail.com",
"archived+ws@hotmail.com",
"dwells@opiclub.com",
"tcantu29@yahoo.com",
"831laurad@gmail.com",
"hancockjohn855@gmail.com",
"j.leblanc21@icloud.com",
"earlineburrell55@gmail.com",
"35801@noemail.upload",
"deuela@yahoo.com",
"bamagrama175@yahoo.com",
"amartin2037@hotmail.com",
"18851@noemail.upload",
"pamdavidlowe@gmail.com",
"79801@noemail.upload",
"89851@noemail.upload",
"cdgordonjr28@hotmail.com",
"4401@noemail.upload",
"jeanfisher@yahoo.com",
"lmwhite137@yahoo.com",
"jeanhfisher@yahoo.com",
"texasextreme@yahoo.com",
"hamrock05@sbcglobal.net",
"madalynederek@aol.com",
"gresensj@yahoo.com",
"terryesingingrealtor@gmail.com",
"archived+luci.pendas@hcahealthcare.com",
"grambo58@sbcglobal.net",
"gracy_salinas@yahoo.com",
"winniedeguia@yahoo.com",
"elizabeth.tia@comcast.net",
"cgdixon481@hotmail.com",
"90951@noemail.upload",
"carlwashburn77@yahoo.com",
"bellasera110@gmail.com",
"bripalacios788@gmail.com",
"72351@noemail.upload",
"lynnemcw2@yahoo.com",
"normaquiles52@gmail.com",
"fcamilli@comcast.net",
"archived+genparker36@yahoo.com",
"haydeesoto2006@hotmail.com",
"dcuela@yahoo.com",
"drlafleur@gmail.com",
"skillman.emily@att.net",
"jknafz@davesworld.net",
"rebeccawhite33@gmail.com",
"cynthiacolbert22@yahoo.com",
"gf418d@aol.com",
"sfbelknap@yahoo.com",
"toni.grider@buildwithbmc.com",
"annehebert@mac.com",
"20301@noemail.upload",
"dodgekat@ymail.com",
"dbisanar@yahoo.com",
"erin_rothchild@yahoo.com",
"mary.l.thomas1023@gmail.com",
"gsr022@yahoo.com",
"rambler14@comcast.net",
"yetundesonaike@hotmail.com",
"melissa.maier17@yahoo.com",
"deepanmody@hotmail.com",
"howzee12@gmail.com",
"grichmond2@gmail.com",
"archived+84801@noemail.upload",
"soorfeet@yahoo.com",
"maricea1963@gmail.com",
"bkjmd@comcast.net",
"lina1343@yahoo.com",
"geniesilva@gmail.com",
"91351@noemail.upload",
"janenoble70@gmail.com",
"janicefjacobs@yahoo.com",
"giserpineda@icloud.com",
"hildybnhm@yahoo.com",
"jennick1980@hotmail.com",
"graysusan55@yahoo.com",
"jcab245236@yahoo.com",
"frekkieb@gmail.com",
"90351@noemail.upload",
"weatherspoondavey@gmail.com",
"nana5grand@hotmail.com",
"gerrymac39@comcast.net",
"tmartinez5670@gmail.com",
"yhall_yh@yahoo.com",
"barbara.morganrn@gmail.com",
"80501@noemail.upload",
"glorivera@yahoo.com",
"rosarioserrano45@gmail.com",
"bb1gmommy@sbcglobal.net",
"augustogoulden@gmail.com",
"mressling@gmail.com",
"debbie1526@yahoo.com",
"cjendron151@gmail.com",
"anamarsalty@yahoo.com",
"1621074585753919069@noemail.hy.ly",
"bcarterlvn@yahoo.com",
"kdowens03091959@gmail.com",
"rick@smithres.com",
"terry_lovesavon@yahoo.com",
"lindalschess@gmail.com",
"marvin.klingenberg@outlook.com",
"isantin54@gmail.com",
"amf1130@aol.com",
"jwey1023@gmail.com",
"ltng2k@gmail.com",
"sherri_armas@yahoo.com",
"marlenelabauve@gmail.com",
"valdez.lupe@gmail.com",
"spollack@entouch.net",
"waymondsmith5@gmail.com",
"asalvador7@my.gcu.edu",
"dpearsh@yahoo.com",
"reneer40@comcast.net",
"bzahnle@att.net",
"zvserrano@gmail.com",
"darrell4566@att.net",
"sdgreer422@gmail.com",
"808-281-1292@anonymous.noemail",
"sam6666@live.com",
"texasgrandmaof1@gmail.com",
"butrgli@gmail.com",
"dtbramlett@gmail.com",
"ddtjones3@gmail.com",
"virginia.marez.vm@gmail.com",
"glendakhayes@yahoo.com",
"arma06@gmail.com",
"archived+mrlaredo33@aol.com",
"joe.muallm@yahoo.com",
"1622398195971814973@noemail.hy.ly",
"lacylineweaver@yahoo.com",
"archived+832-276-1072@anonymous.noemail",
"210-267-7654@anonymous.noemail",
"one4jrs@gmail.com",
"archived+shanehatler@icloud.com",
"000-000-00@anonymous.noemail",
"kmayrose@att.net",
"debraq@cincoranchace.com",
"281-814-2101@anonymous.noemail",
"shanehatler@icloud.com",
"713-822-7117@anonymous.noemail",
"ramonao2013ic@gmail.com",
"salonzo3@yahoo.com",
"586-677-3980@anonymous.noemail",
"deana.simpson@icloud.com",
"neeleew@yahoo.com",
"pcdmomtc@gmail.com",
"ataya.shields32@gmail.com",
"debarah_wilson@bellsouth.net",
"73151@noemail.upload",
"amgrassi@comcast.net"
];

//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////

export const users = [
"John Olivarez",
"Norma Campa",
"David Alatorre",
"Sonia Rodriguez",
"Anne Hebert",
"Rosalie Beckwith",
"Dora Gonzalez",
"Cecil (Jay) Jorns",
"Dale Black",
"Lynda Rutledge",
"Loretta Clark",
"JoAnn Zubik",
"Coy Dean",
"John Rehage Jr",
"Lori Rehage",
"Loretta Clark",
"Catharina Townes",
"Margaret Stuart",
"Linda Woodward",
"Marilyn Starry",
"Jessica Bonneau",
"Charles Ronnenkamp",
"Sandra Toms",
"Pat Marshall",
"Geraldine Smith",
"Caroline Hessell",
"Nancy Rosenbaum",
"Rosalie Alley",
"Mable Horn",
"Ann Adams",
"James Gray",
"Lorelei Skabowski",
"Jan Gillespie",
"John Rusak",
"Jennifer Molina",
"Peggy Davis",
"Bob Lane",
"Binder Moreland",
"Liz Weiman",
"Doe Cantrell",
"Janet Armstrong",
"Antionette Vanado",
"Laura Platt",
"Veronica Latuff",
"Alicia Kahler",
"Margaret Stuart",
"David Kech",
"Robert Denton",
"Joel Acosta",
"Lori Caldwell",
"Hunter Quiel",
"Opal White",
"Hamer Sharon",
"Joann Bloom",
"Lana Moody",
"Lloyd McLennon",
"Susan Whitman",
"Margaret Given",
"Joe Kidd",
"George Vickers",
"Yolanda Calderon",
"Dora Gonzalez",
"Nancy Martin",
"Frankie Smith",
"BeckwithRosali Rosalie Beckwith",
"Alice Brummer",
"Bridget Waterman",
"Mary Hardiman",
"Carlos Robles",
"Terence Chow",
"Carla Romero",
"LYDIA RIOS",
"Kimberly Ochoa",
"Gregory Schowalter",
"Olan Sherbert",
"Vangie Robinson",
"Joyce Russell",
"Edgar Nolastname",
"Donna Bar",
"Deborah Rucker",
"Thomas Enz",
"Randy Saunders",
"Onesia Pavich",
"Steve Rioux",
"Leonora Andreozzi",
"Sharon Barnes",
"Lettie Galvan",
"Deanne Bynum",
"Rene Rivera",
"Rosalinda (Rosie) Gonzalez",
"Mary Mclean",
"Dale Black",
"Migdalia Rivera",
"Wanda Stewart",
"Carlos Acevedo",
"Maria Borrero",
"Donna Richards",
"Cecilla (Cissy) Bell",
"Cecilla (Cissy) Bell",
"Joanne Shepherd",
"Larry Levy",
"Jeannette Stevens",
"Laverne Hassan",
"Debbie Castilllo",
"Brian Williams",
"Jay Jorns",
"william paige",
"Rouen Caboche",
"Sherry Koenig",
"Stephen Griffin",
"Valentino E",
"Henry (Mill) Whitehead",
"Lynne Poage",
"Marilyn Hurley",
"Edna Lewis",
"Joyce Rader",
"Marryanne Zbranek",
"Mona Mulhollan",
"Ethan & Laura Reed",
"Nena Brito",
"Ana Lugo",
"Edward Turknett",
"Mary Catherine Mills",
"Margaret Durham",
"Kathleen Crespy",
"Melissa White",
"Beverly Stuart",
"Anthony DeNome",
"Rebecca Yerdon",
"Shirley Rogers",
"Joanne Harris",
"James Early",
"Larry Keith",
"Tom and Annie Frick",
"Reese Mary",
"Gina Mendez",
"Margaret Bernard",
"Haas Dorothy",
"rachel grendell",
"Phyllis Sedberry",
"Aileen Berino",
"Silvia Daugherty",
"Richard Uranga",
"Lorrie Cherry",
"Linda Nodler",
"Duplicate Karl and Mozelle Duchemin",
"Rosa Given",
"Bill Wells",
"Ferrie May",
"Robert Johnston",
"Heather Sturgill",
"Delores Lopez",
"Mark Min",
"Deah Chamberlain",
"Leonor Martin",
"Shannon Bowen",
"Kimberly Savage",
"Gail Turley",
"Joy Moore",
"Debbie Ridley",
"Ron & Cheryl Gothberg",
"Ronald Mack",
"Barbara Clarkson",
"Nicole Moeller",
"Angelett Pugh",
"Maria Cantu",
"Leigh Anne Kindred",
"Kristen Fox",
"Ruth Pankiw",
"Jenifer Monts",
"Christine Gatlin",
"Rita Martinez",
"Joyce Cherek",
"Paula Harold",
"Patricia Baldwin",
"Jennifer Dawson",
"Linda B Graham",
"Mark Mittelsted",
"Nellie Smith",
"Linda & Ed Gresham",
"Jessica Bonneau",
"Billy Maguire",
"Stephanie LaFleur",
"Sonny Soleman",
"Jody Osteen",
"Dorothy McGinnis",
"Wilma Smith",
"David Wells",
"terri cantu",
"Harris Laura",
"John Hancock",
"Janet LeBlanc",
"Earline Burrell",
"Jesse Ramirez",
"Anita Deuel",
"BOUGHT A HOUSE - Donna Galli",
"Irene Martin",
"Bradley Hooks",
"Carolyn David",
"Kay McCasland",
"Unavailable William",
"Clyde Gordon",
"Jane Williams",
"Jean Fisher",
"Lillie White",
"Jean Fisher",
"Tracy Tijerina",
"Greg Hamrock",
"Danyell Wilkerson",
"Joanne Gresens",
"Terry Ely",
"Luci Pendas",
"Minerva Rodriguez",
"Margarita Salinas",
"Winnie DeGuia",
"Elizabeth Tia",
"Carol Dixon",
"Selvidge Loretta",
"Carl Washburn",
"Queen Hopkins",
"Brianna Palacios",
"Fred Castle",
"Lynne McWilliams",
"Norma Quiles",
"Frank Camilli",
"Genevieve Parker",
"Haydee Soto",
"Anita Diaz",
"Lafleur Jake",
"Emily Skillman",
"Keith Nafziger",
"Rebecca White",
"Brenda Bosie",
"Greg Freeman",
"Sarah Belknap",
"Toni Grider",
"Anne Cochran",
"Margaret Robinson",
"Kathy dodge",
"Diana Bisanar",
"Erin Rothchild",
"Mary Thomas",
"Gus Rao",
"Ann Hayes",
"Susanna Sonaike",
"Melissa Maier",
"Deepan Mody",
"Bridget Howze",
"George and Carolyn Richmond",
"Melissa Fort Lauder",
"Sharon Macias",
"Marisela Solis",
"Brenda Domagala",
"Robert and Eva Lara",
"Genie Canedo",
"John Barnett - TOO EXPENSIVE",
"Jane Noble",
"Janice Jacobs",
"Mireya Pineda",
"Hiltraut Benham",
"Martha and Gilbert Garcia",
"Susan Gray",
"Josie Caballero",
"Frekkie Williams",
"Stephan Hickman",
"Davey Weatherspoon",
"Jeanette Erickson",
"Gerry McElhannon",
"Robert Rodriguez",
"Yvonne Hall",
"Barbara Morgan",
"Cynthia Lang",
"Gloria Matos",
"Rosario Serrano",
"Barb Shelby",
"Augusto Goulden",
"Melissa Ressling",
"Debbie Fitzsimmons",
"Claudia Jendron",
"Ana Siman",
"Rebecca Carter",
"Karen Owens",
"Richard Smith",
"Maria Castro",
"Linda Schess",
"Marvin Klingenberg",
"Isabel santin",
"Andrea Foley - MOVED TO SOLEA CEDAR PARK",
"Jason Wey",
"Lori Eng",
"Sherri Armas",
"Marlene Labauve",
"Guadalupe Valdez",
"Shannon Pollack",
"Waymond Smith",
"Angela Salvador",
"Dorothy Peterson",
"Renee Petrillo",
"Alan & Barbara Zahnle",
"ZULMA V SERRANO",
"Darrell Keith",
"Sylvia Greer",
"Marilyn Tsang",
"Sam rohrback",
"Gayla Hymer",
"Carolyn Gipson",
"Dennis Bramlett",
"Diane D. Jones",
"Virginia Marez",
"Glenda Hayes",
"Ana Madrid",
"Lawrence and Margaret Lucido",
"Joe Muallem",
"Lacy Lineweaver",
"Sue Laine",
"Evette Ardito",
"James Sutton",
"Grady Stephens",
"Spam Anonymous",
"Alan and kathy Mayrose",
"Debra Quirk",
"Janine Heard",
"Grady Stephens",
"Denise Breeze",
"Ramona Ordonez",
"Shari Alonzo",
"Sharon Vagey",
"Deana Cannon",
"Neele Walker",
"Patricia Dean",
"Ataya Shields",
"Debarah H Wilson",
"Lorena McMullen",
"Anneliese Grassi",
"Ross Patton",
"Rich Sullivan",
"Clifford Cunningham",
"Connie Woodford",
"Sharon Hamilton",
"Debbie G",
"Pat Mack",
"Esther Madison Panti",
"Desiree Garcia",
"210-574-2468 Anonymous",
"Beatriz Grimes",
"Harry Grayum",
"Mindy Sytsma",
"Danny Calderon",
"Theresa Boyd",
"Joan Burns",
"Caroline Penn",
"Rose Rahm",
"Ethel Alexander",
"Elsa Bautista",
"Anna Baptiste",
"318-497-2180 Anonymous",
"Denise McShan-Paige",
"Mary Mclean",
"David Batchelor",
"Robin Dye",
"Maria Fernandez",
"210-508-8085 Anonymous",
"Linda Reynolds",
"Susan Jones",
"Floyd Duzant",
"Mike Slamen",
"Bob Feagin",
"Anita Gamel",
"Katherine Brown",
"Sharon Moore",
"Tanya Cory",
"Patricia Dowling",
"281-380-9067 Anonymous",
"David Chong",
"Brenda Prendergast",
"266-696-687 Anonymous",
"323-657-4541 Anonymous",
"Rita Maslowski",
"Vickie Dominguez",
"Larry Huerter",
"JAymin Prajapati",
"Patrice Stark",
"Cam Arms",
"LeeAnn Hill",
"Linda Harris",
"Janet Thienpont",
"James Francisco",
"Kenda Frazier",
"Edward Luna",
"larry smith",
"Mary Lou Williams",
"Shirley Brown",
"Sandra No Name",
"Carmen No Name Two",
"Stacey Gobert",
"Nancy Johnson",
"Sue Laine",
"Carolyn Watkins",
"DANIEL PEREZ",
"Catharina Townes",
"Linda Frank",
"469-299-5529 Anonymous",
"Joan Bowman",
"Susan Slemp",
"Mira ElShammaa",
"DeAnne Kelly",
"Lil Mursuli",
"Glenn Burleson",
"Rose Ann Murray",
"Becky Barrera",
"Mary Stewart",
"Jennifer Sherowski",
"Myriam Ruiz",
"DeAnn Kelly",
"Sharon Criscione",
"Sharon Criscione",
"Carol Metz",
"Sandra Griffin",
"Vanessa Brocheros",
"Debbie Perez",
"Tomas Anonymous",
"Dr. Rinaldi",
"William (Bill) Boschma"
]

//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////


export const roles = [
  "admin",
  "property_manager",
  "regional_manager",
  "org_manager"
]

//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////

export const properties = [
  "keview at Superstition Springs",
  "Waterfield Square Apartment Homes",
  "Village at Lake Park",
  "The Channel",
  "Essex on the Park",
  "Woodfall Greens",
  "Solaire 8250",
  "The Eugene",
  "Canvas Valley Forge",
  "The Octagon",
  "The Banks",
  "The Cooper",
  "Arbors at Baltimore Crossroads",
  "Legacy West End",
  "Luminary at One Light",
  "Signature",
  "L Seven Apartments",
  "Hecht Warehouse",
  "The Berkleigh",
  "OMNIA at Town Center",
  "The Lindley",
  "Aliso",
  "The Pioneer",
  "465 North Park",
  "727 West Madison",
  "The Lumin at Boca Raton",
  "Rize Irvine Apartments",
  "808 West Apartments",
  "Clippership Apartments on the Wharf",
  "Highland Park",
  "Avalia",
  "The Sinclair",
  "The Shay",
  "Elevation at Washington Gateway",
  "Monroe Street Market",
  "Arbors at Arundel Preserve",
  "Indigo 301",
  "The Wellington",
  "1000 South Clark",
  "Meriel Marina Bay",
  "Monument Village at College Park",
  "Exo Reston",
  "Halstead Square Lotus & Lofts",
  "Incanto",
  "Solaire Silver Spring",
  "The Beacon of Groveton",
  "Two Light Luxury Apartments",
  "Marc",
  "Novel South Capitol",
  "Riverside",
  "Winthrop",
  "Chelsea 88",
  "Alston",
  "The Metropolitan Rockville Town Center",
  "Cameron Court",
  "OneEleven",
  "Cortland Lake Lotus",
  "The Witmer",
  "Cortland at the Battery Atlanta",
  "Vela on Ox",
  "Highgate",
  "450K",
  "One Light Luxury Apartments",
  "Coda on H",
  "One Greenway",
  "The Modern at Art Place",
  "Cirrus Apartments",
  "Liberty Harbor East",
  "Flats170 at Academy Yard",
  "Lakeside Apartments",
  "Element Uptown",
  "70 Capitol Yards",
  "Park 83",
  "Yale West",
  "The Hepburn",
  "The Esplanade at National Harbor",
  "Enclave at Box Hill",
  "Courtney Village",
  "Centrum Bucktown",
  "Cortland West Boynton",
  "The Jefferson at Fair Oaks",
  "Stone Point Apartments",
  "Left Bank",
  "HUBBARD221",
  "The Modern - 100 Park",
  "Marquee at Block 37",
  "Roosevelt Collection Lofts",
  "Citizen Perimeter",
  "The Point at Pine Ridge",
  "Niido Nashville",
  "The Lex",
  "The Eden",
  "Residences on the Avenue",
  "The Daley",
  "One Beachmont",
  "Beach House Revere",
  "Viridian",
  "Hunters Glen",
  "Museum Tower",
  "VITA Tysons Corner Center",
  "800 Carlyle",
  "Central",
  "100 Capitol Yards",
  "The Kenmore",
  "Potomac Vista",
  "Crosswinds at Annapolis Towne Centre",
  "Spectra at Sibley Square",
  "Spinnaker Bay at Harbor East",
  "Harlow",
  "Andorra Apartments",
  "Corsair",
  "The Hamilton",
  "Regent's Park",
  "Windridge Apartments",
  "The James at Sugarloaf",
  "77 H",
  "Falls Green",
  "Cortland North Druid Hills",
  "1500 Locust",
  "301 M",
  "Dalian on the Park",
  "672 Flats",
  "K2 Apartments",
  "The Metropolitan",
  "AQUABLU",
  "West141",
  "Allegro",
  "The Kensington",
  "1213 Walnut",
  "Cambridge Park Apartments",
  "Azure Oxford Square",
  "The Haven at Atwater Village",
  "Cadence at Crown",
  "Chalfonte",
  "Concord Crystal City",
  "Rhode Island Row",
  "The Porter Del Ray",
  "Cortland Decatur East",
  "The Avant at Reston Town Center",
  "The Shelby",
  "Halstead Station",
  "Ovation at Park Crest",
  "ORA Flagler Village",
  "Hy.ly 1 Test Property",
  "Jack Flats",
  "Riverbank",
  "Parc Huron",
  "The Harvey",
  "Flats at Atlas",
  "The Batch Yard",
  "Ashby at McLean",
  "Arkadia West Loop",
  "West Broad",
  "The Gramercy at Town Center",
  "Lex at Waterfront Station",
  "Mariner Bay at Annapolis Towne Centre",
  "The Audubon New Haven",
  "Milagro Coral Gables",
  "Carlton Park",
  "Rivergate",
  "TENm.Flats",
  "Astor Place",
  "Aperture",
  "7SEVENTY7",
  "Reed Row",
  "Eleven 40",
  "Verse Condominiums",
  "Cortland Jubilee Park",
  "360 State Street",
  "Lakehouse",
  "The Residences at Eastern Market",
  "Amberleigh",
  "Montage Rocky Hill",
  "Tempo Evergreen Walk",
  "The Parker",
  "Pike 3400",
  "Talleyrand Apartments",
  "Monarch",
  "The Isle",
  "Devonshire",
  "The Metropolitan Downtown Columbia",
  "2001 Clarendon Boulevard",
  "Cortland Hunter's Creek",
  "Bennett Park",
  "The Royal Athena",
  "Flats 8300",
  "One Glastonbury Place",
  "The Vine",
  "The Addison",
  "Sterling Parc at Hanover",
  "The Apartments at CityCenter",
  "3801 Connecticut Avenue",
  "Willow Grove Apartment Homes",
  "Halstead Malden Square",
  "Cortland Bellevue",
  "The Whitney",
  "Fuse Cambridge",
  "The Bradley",
  "The Acadia at Metropolitan Park",
  "Vantage Mosaic",
  "15777 Quorum",
  "The Maxwell",
  "The Allure Mineola",
  "The Point at Still River",
  "15 Bank Apartments",
  "The Park",
  "Valentia Apartments",
  "The Victor",
  "The Frasier",
  "Chesapeake Ridge",
  "Anthem House",
  "The Morgan",
  "Element One",
  "The Mark Living",
  "Twenty|20",
  "Paseo at Bee Cave by Cortland",
  "Westwind Farms Apartments",
  "South Beach Apartments",
  "Garfield Park",
  "The M on Hennepin",
  "Inwood Station",
  "Union on Queen",
  "Glasshouse Pittsburgh",
  "The Bexley",
  "Alterra",
  "The Beacon-Criterion",
  "Millstone at Kingsview",
  "The Zenith",
  "7001 Arlington at Bethesda",
  "Masons Keepe",
  "Palette at Arts District",
  "Waverly Place",
  "The Yards at Fieldside Village",
  "Hub50House",
  "Strathmore Court at White Flint",
  "1331",
  "Instrata at Mercedes House",
  "Broadview Apartments",
  "Halstead Milford",
  "The Elms at Montjoy",
  "Enclave at Potomac Club",
  "Montfair at the Woodlands",
  "Solea Alamo Ranch",
  "The Paramount",
  "Chestnut Square",
  "The Elms at Kingstowne",
  "Bethesda Hill",
  "Instrata Pentagon City",
  "Watertown Mews",
  "The Elms at Shannon’s Glen",
  "Cortland Waters Edge",
  "Harbor View",
  "Newseum Residences",
  "Loren",
  "The Millennium at Metropolitan Park",
  "The Courts of Devon",
  "Heirloom Flats",
  "Two West",
  "Areum Apartments",
  "The Elms at Oakton",
  "The Apartments at Harbor Park",
  "The Promenade at Harbor East",
  "The Flats at Neabsco",
  "Arcadia Run III",
  "Roosevelt Towers",
  "Metro 303",
  "One Theater Square",
  "The Elms at Stoney Run Village",
  "Crystal Square Apartments",
  "The Dylan",
  "Vue32",
  "The Julian at Fair Lakes",
  "Arcadia Run",
  "One Cardinal Way",
  "Ventura Pointe",
  "Cantabria at Turtle Creek Apartments",
  "The Elms at Kendall Ridge",
  "The Racquet Club",
  "The Eliot on Ocean",
  "The Arbors on Duke",
  "Enclave at Emerson",
  "Avenue at York",
  "Cathedral Commons",
  "Currents on the Charles",
  "Talia Apartments",
  "Sparrows Point",
  "Elan Yorktown",
  "Flats on D",
  "The Elms at Centreville",
  "Park Adams",
  "Caesura",
  "The View at Liberty Center",
  "Solaire Bethesda",
  "Clayborne Apartments",
  "West 130 Apartments",
  "Element 28",
  "Greene Manor",
  "Beach Place Apartment Homes",
  "The Elms at Old Mill",
  "Silverwood Farm",
  "Park + Garden",
  "Boulevard at B",
  "Solea Cinco Ranch",
  "Sedona|Slate",
  "The Elms at Arcola",
  "The Elms at Clarksburg Village",
  "MetroPointe",
  "The Village at Taylor Pond",
  "The Tannery",
  "Edgemoore",
  "Townsend Square",
  "Cortland Riverside",
  "880 P",
  "The Harlo",
  "5333 Connecticut",
  "Coeval",
  "Jamison Park",
  "2255 Wisconsin",
  "Niido Orlando",
  "30 Dalton",
  "LINCOLN",
  "The Elms at Signal Hill Station",
  "Monarch",
  "New Village at Patchogue",
  "Enclave at Box Hill II",
  "Bridges at Chapel Hill",
  "The Gunther",
  "The Metropolitan at Village at Leesburg",
  "The Elms at Germantown",
  "The Elms at Falls Run",
  "Centrum Evanston",
  "ELLIPSE BUILDING LLC",
  "Spoke",
  "The Lex at Brier Creek",
  "Cortland Gateway Park",
  "13 | U",
  "Paraiso At Fountain Square",
  "Stamford Corners",
  "The Beacon-Hague",
  "The Beacon-Paramount",
  "The Dalton",
  "The Townes at Harvest View",
  "Oasis at Montclair",
  "Belvoir Square",
  "PARKSIDE WEST",
  "The Lexington at Market Square",
  "Hahne & Co",
  "Sanger Place",
  "321 SOUTH BROAD",
  "A2",
  "Crane Chinatown",
  "ATLANTIC",
  "PARKSIDE EAST",
  "PACIFIC",
  "The Elms at Clarksburg Village Encore",
  "Shay - West",
  "Holly Oaks",
  "The Beacon-Orpheum",
  "WATERSIDE SQUARE NORTH",
  "EMBANKMENT",
  "Nine15",
  "The Upton",
  "Solaire Wheaton",
  "Timberlawn Crescent",
  "The Beacon-Tower",
  "Cascades Overlook",
  "RIVERSIDE",
  "Avenue at A",
  "VY Reston Heights",
  "1405 Point",
  "EAST HAMPTON",
  "Xavier Chicago",
  "Solea Keller",
  "The Broad Exchange Building",
  "The Beacon-Mercury",
  "County Center Crossing",
  "ROOSEVELT",
  "LAGUNA",
  "Jericho Residences",
  "Instrata Park Slope",
  "Hy.ly Sales",
  "The Watch on Shem Creek",
  "Palmetto Grove",
  "WATERSIDE SQUARE SOUTH",
  "SOUTHAMPTON",
  "Mallory Square",
  "Hyly Customer",
  "Heritage Pointe",
  "The Fields at Merrifield",
  "The Fields of Bethesda",
  "The Avenue at York (Test)",
  "Highline Union Market",
  "Dock 79",
  "Fairmont Apartments",
  "Springfield Crossing",
  "The Pointe at Midtown",
  "Tree Top Apartments",
  "Vista Laurel Highlands",
  "The Link",
  "Trails of Sanger Apartments, LLC",
  "Village - Cambria (Pivotal UAT)",
];

//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////

export const authorized_apps = [
  "hyTour",
  "hyMail",
  "hyALM",
  "hyCRM",
  "hyChat",
  "hyBlast",
  "hySurvey",
]

//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
